// extracted by mini-css-extract-plugin
export default {"container":"tableModal_container__Bxlnf","content":"tableModal_content__cKWxh"};